import React from "react";
import { Footer } from "../../components";

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="bg-green-900 min-h-screen text-white flex flex-col font-sans">
      <section className="py-16 px-6 md:px-16 text-center bg-green-800">
        <h1 className="text-4xl md:text-6xl font-extrabold text-yellow-400">Politique de Confidentialité</h1>
        <p className="mt-4 text-lg text-gray-200 max-w-3xl mx-auto">
          Dernière mise à jour : {new Date().getFullYear()}
        </p>
      </section>

      <section className="flex-grow px-6 md:px-16 py-10 space-y-10 text-gray-100">

        <div>
          <h2 className="text-2xl font-bold text-green-300 mb-2">1. Présentation</h2>
          <p>
            Mediiq est une plateforme numérique opérée par 
            <strong> Loven Software Development SARL U</strong>.
            Cette politique explique comment nous collectons, utilisons et protégeons vos données.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-green-300 mb-2">2. Données collectées</h2>
          <p>
            Nous collectons uniquement les informations strictement nécessaires :
          </p>
          <ul className="list-disc ml-6 mt-2">
            <li>Nom et prénom</li>
            <li>Numéro de téléphone</li>
            <li>Adresse email</li>
            <li>Localisation (uniquement avec votre permission)</li>
            <li>Historique de commandes</li>
            <li>Données techniques (modèle de téléphone, version de l’app)</li>
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-green-300 mb-2">3. Comment vos données sont utilisées</h2>
          <p>Vos données servent uniquement à : </p>
          <ul className="list-disc ml-6 mt-2">
            <li>Vous aider à trouver des pharmacies proches</li>
            <li>Transmettre vos commandes aux pharmacies partenaires</li>
            <li>Assurer la sécurité du compte</li>
            <li>Améliorer l’expérience utilisateur</li>
          </ul>
          <p className="mt-2">
            Mediiq <strong>ne vend jamais</strong> vos données à des tiers.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-green-300 mb-2">4. Pharmacies partenaires</h2>
          <p>
            Les pharmacies reçoivent uniquement les données nécessaires à la préparation 
            et au traitement de votre commande.  
            Elles ne peuvent pas utiliser vos informations à des fins marketing sans votre accord.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-green-300 mb-2">5. Sécurité</h2>
          <p>
            Nous utilisons des technologies modernes (HTTPS, chiffrement, serveurs sécurisés)
            pour protéger vos données contre l'accès non autorisé.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-green-300 mb-2">6. Vos droits</h2>
          <p>Vous pouvez demander :</p>
          <ul className="list-disc ml-6 mt-2">
            <li>L’accès à vos données</li>
            <li>La suppression de votre compte</li>
            <li>La correction de vos informations</li>
          </ul>
          <p className="mt-2">
            Envoyez-nous un email à : 
            <a className="underline text-yellow-300 ml-1" href="mailto:privacy@mediiq.app">
              privacy@mediiq.app
            </a>
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-green-300 mb-2">7. Contact</h2>
          <p>
            Pour toute question liée à la confidentialité, contactez :  
            <a href="mailto:support@mediiq.app" className="underline text-yellow-300 ml-1">
              support@mediiq.app
            </a>
          </p>
        </div>

      </section>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
